module.exports = __webpack_public_path__ + "static/media/employment.7cd77368.jpg";